import React from 'react';
import QRCode from 'qrcode.react';

function PublicUrlQrCode({
  generatedPublicUrl,
  qrTransparentBackground,
  qrPreviewSize,
  fgColor,
  bgColor,
  qrPreviewRef,
  qrExportPngRef,
  qrExportSvgRef,
  onDownloadPng,
  onDownloadSvg,
  onQrBackgroundModeChange,
  onQrPreviewSizeChange,
}) {
  const rawQrValue = String(generatedPublicUrl || '').trim();
  const qrValue = rawQrValue
    .replace(/^https?:\/\/www\./i, 'https://')
    .replace(/^http:\/\//i, 'https://');

  return (
    <div className="pf-public-url">
      <h3 className="pf-public-url__title">Public Profile URL QR Code</h3>

      <p></p>

      <div className="pf-public-url__bg-row">
        <span className="pf-public-url__bg-label">Qr Code Background</span>
        <div className="pf-qrbg-bar" role="group" aria-label="QR background mode">
          <button
            type="button"
            className={`pf-qrbg-btn ${!qrTransparentBackground ? 'active' : ''}`}
            onClick={() => onQrBackgroundModeChange(false)}
            aria-pressed={!qrTransparentBackground}
          >
            Theme
          </button>
          <button
            type="button"
            className={`pf-qrbg-btn ${qrTransparentBackground ? 'active' : ''}`}
            onClick={() => onQrBackgroundModeChange(true)}
            aria-pressed={qrTransparentBackground}
          >
            Transparent
          </button>
        </div>
      </div>

      <div className="pf-public-url__size-row">
        <label htmlFor="qr-size-slider" className="pf-public-url__bg-label">QR size</label>
        <div className="pf-public-url__size-control">
          <input
            id="qr-size-slider"
            type="range"
            min="72"
            max="420"
            step="2"
            value={qrPreviewSize}
            onChange={(e) => onQrPreviewSizeChange?.(e.target.value)}
            aria-label="QR preview size"
          />
          <span className="pf-public-url__size-value">{qrPreviewSize}px</span>
        </div>
      </div>

      {generatedPublicUrl && (
        <div className="pf-public-url__preview">
          <div className={`pf-public-url__qr ${qrTransparentBackground ? 'is-transparent-bg' : ''}`} ref={qrPreviewRef}>
            <QRCode
              value={qrValue || generatedPublicUrl}
              size={qrPreviewSize}
              level="L"
              includeMargin={false}
              fgColor={fgColor}
              bgColor={bgColor}
            />
          </div>
          <div className="pf-public-url__exports" aria-hidden="true">
            <div ref={qrExportPngRef}>
              <QRCode
                value={qrValue || generatedPublicUrl}
                size={3000}
                level="L"
                includeMargin={false}
                fgColor={fgColor}
                bgColor={bgColor}
              />
            </div>
            <div ref={qrExportSvgRef}>
              <QRCode
                value={qrValue || generatedPublicUrl}
                size={1200}
                level="L"
                includeMargin={false}
                renderAs="svg"
                fgColor={fgColor}
                bgColor={bgColor}
              />
            </div>
          </div>
          <a
            href={generatedPublicUrl}
            target="_blank"
            rel="noreferrer"
            className="pf-public-url__link"
          >
            {generatedPublicUrl}
          </a>
          <button
            type="button"
            className="pf-btn dark"
            onClick={onDownloadPng}
          >
            Download QR PNG (3000px)
          </button>
          <button
            type="button"
            className="pf-btn dark"
            onClick={onDownloadSvg}
          >
            Download QR SVG
          </button>
        </div>
      )}
    </div>
  );
}

export default PublicUrlQrCode;
